import { InfoCell } from '@/components/shared/InfoCell';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface MonthlyTotalHeaderProps {
  showDayTotals?: boolean;
}

export const MonthlyTotalHeader: FC<MonthlyTotalHeaderProps> = () => {
  return (
    <InfoCell className={twMerge('flex-1')}>
      <p>{strings.common.totals.monthlyTotal}</p>
    </InfoCell>
  );
};
